import {
  gql 
} from "@apollo/client";

export const ADD_WHOLESALE_PROGRAM = gql`
mutation addWholesaleProgram(
    $email: String!
    $firstname: String!
    $lastname: String!
    $phone: String!
    $storelocation: String!
    $website: String!
    $businesstype: String!
    $interested: String!
    $noyib: String!
    $itremark: String
    $howknow: String!
    $hkremark: String
    $story: String
  ) {
    addWholesaleProgram(
      input: {
        email: $email
        firstname: $firstname
        lastname: $lastname
        phone: $phone
        storelocation: $storelocation
        website: $website
        businesstype: $businesstype
        interested: $interested
        noyib: $noyib
        itremark: $itremark
        howknow: $howknow
        hkremark: $hkremark
        story: $story
      }
    ) {
      code
      message
      content
    }
  }
`;

export default {
  addWholesaleProgramMutation: ADD_WHOLESALE_PROGRAM
};
